import { type XYChartState } from '../types/state.js';

export function reducePanDomain(domain: XYChartState['currentDomain']) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    currentDomain: domain,
    highlightedSeriesId: undefined,
    select: undefined,
  });
}
